import { FIVE_MINUTES_IN_MILISECONDS } from 'common/Utils/DateUtils'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { getPartsFiles } from 'store/actions'

/**
 * global variable to track when was the last time a specific file was refreshed, to avoid getting stuck in a loop trying to refresh the same link infinitely if it fails for a different reason than simply being expired
 * @type {Map<number, number>}
 */
const lastRefreshAttemptPerPart = new Map()

/**
 * this hook is only used in PartImg (which is used in may places) and in StlViewer
 * @param {number} partId
 * @returns {{ onLoadPartFileError: () => void }} returnedObj
 */
export const useRefreshPartFilesOnError = (partId) => {

	const dispatch = useDispatch()

	const onLoadPartFileError = useCallback(() => {
		if (partId == null) return

		// get timestamp tracking:
		const lastRefreshAttempt = lastRefreshAttemptPerPart.get(partId)

		// if last refresh was less than 5 minutes ago, dont refresh again:
		if (lastRefreshAttempt != null && Date.now() - lastRefreshAttempt < FIVE_MINUTES_IN_MILISECONDS) {
			// last refresh was less than 5 minutes ago -> do nothing
			return
		}

		// update timestamp tracking:
		lastRefreshAttemptPerPart.set(partId, Date.now())

		// refresh:
		dispatch(getPartsFiles([partId]))
	}, [
		partId,
		dispatch,
	])

	return { onLoadPartFileError }
}
